import styled from 'styled-components';

export const AdminAccountWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;
